import { useLayoutEffect } from 'react';
import { useAppLogo } from '@/contexts/LogoProvider';

const FAVICON_SELECTORS = [
  'link[rel="icon"][sizes="32x32"]',
  'link[rel="icon"][sizes="16x16"]',
  'link[rel="icon"][sizes="192x192"]',
  'link[rel="apple-touch-icon"]',
] as const;

/** Updates tab / PWA icon links when the main-app org logo is loaded. */
export default function DocumentFavicon() {
  const logoSrc = useAppLogo();

  useLayoutEffect(() => {
    for (const selector of FAVICON_SELECTORS) {
      const link = document.querySelector(selector);
      if (link instanceof HTMLLinkElement) {
        link.href = logoSrc;
        link.type = 'image/png';
      }
    }
  }, [logoSrc]);

  return null;
}
